import React, { MutableRefObject } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '../../components/Button';
import { identifyComponent } from '../../util';

export const copyText = (elem: HTMLTextAreaElement | HTMLInputElement | null): boolean => {
  window.getSelection()?.removeAllRanges();
  try {
    if (!elem) throw new Error('elem not found');
    elem.focus();
    elem.select();
    if (document.execCommand('copy')) {
      return true;
    } else {
      throw new Error("Failed to execCommand('copy')");
    }
  } catch (e) {
    console.warn(`Failed to copy to clipboard: ${e}`);
    return false;
  }
};

export interface CopyButtonProps
  extends Omit<React.ComponentProps<typeof Button>, 'onClick' | 'children'> {
  /**
   * Functions to call when user clicks the Copy button (successfully or not).
   * */
  onCopy?: { success: () => void; error: () => void };
  /**
   * The ref of the input that that should be selected to copy the text of.
   */
  textRef: MutableRefObject<HTMLInputElement | null> | MutableRefObject<HTMLTextAreaElement | null>;
}

export const CopyButton: React.VFC<CopyButtonProps> = ({ onCopy, textRef, ...rest }) => (
  <Button
    data-component="CopyButton"
    variant="fill-primary"
    iconLeft="copy"
    testId="copy-button"
    onClick={() => {
      if (textRef?.current && copyText(textRef?.current)) {
        onCopy?.success();
      } else {
        onCopy?.error();
      }
    }}
    {...rest}
    {...identifyComponent('copy-button', rest)}
  >
    <FormattedMessage defaultMessage="Copy" id="4l6vz1" />
  </Button>
);
